<template>
  <div class="pa-4">
    <v-checkbox label="Đã đóng học phí" v-model="onFee" hide-details />
    <div>
      <v-checkbox label="Chuyên cần" v-model="onAttendance" hide-details />
      <div style="width: 200px" class="mt-3" v-if="onAttendance">
        <BaseInput label="Tỉ lệ có mặt" v-model="attendancePercentage" hide-details />
      </div>
    </div>
    <div>
      <v-checkbox label="Điểm thi" v-model="onMark" hide-details />
      <div style="width: 200px" class="mt-3" v-if="onMark">
        <BaseInput label="Số điểm thi" v-model="markNumber" hide-details />
      </div>
    </div>
    <div class="d-flex justify-end">
      <v-btn depressed dark color="#0D47A1" @click="onSave">Lưu</v-btn>
    </div>
  </div>
</template>
<script>
import BaseInput from '../../../../components/basic/BaseInput.vue'
import { mapActions, mapGetters } from 'vuex'
export default {
  components: { BaseInput },
  data() {
    return {
      onFee: false,
      onAttendance: false,
      attendancePercentage: 0,
      onMark: false,
      markNumber: 0,
    }
  },
  computed: {
    ...mapGetters({
      examCondition: 'grade/getExamCondition',
    }),
  },
  methods: {
    ...mapActions({
      updateGradeIndependent: 'grade/updateGradeIndependent',
    }),
    refresh(source = {}) {
      Object.assign(this.$data, source)
    },
    async onSave() {
      try {
        await this.updateGradeIndependent({ id: this.$route.params.id, examCondition: this.$data })
        this.$alert.success('Cập nhật điều kiện thi thành công!')
      } catch {
        this.$alert.error('Cập nhật điều kiện thi thất bại')
      }
    },
  },
  watch: {
    examCondition: {
      handler(val) {
        if (val) {
          this.refresh(val)
        } else {
          this.refresh(this.$options.data.apply(this))
        }
      },
      immediate: true,
    },
  },
}
</script>
